// Mirrors legacy IDDS::Status (tracker:app/models/idds/status.rb) — keep both tables exact.
const TETRA_TO_DISPLAY = {
    60018: 0,
    38775: 1,
    38770: 2,
    38771: 3,
    38772: 4,
    38773: 5,
    38774: 6,
    36878: 7,
    38776: 8
}

const COLORS = {
    1: ["#20c997", "#ffffff"],
    2: ["#f461ac", "#ffffff"],
    3: ["#f47979", "#ffffff"],
    4: ["#f50806", "#ffffff"],
    5: ["#FFD514", "#000000"],
    6: ["#198754", "#ffffff"],
    7: ["#0dcaf0", "#ffffff"],
    8: ["#6c757d", "#ffffff"]
}

const DEFAULT_COLORS = ["#000000", "#ffffff"]

// raw TETRA code (string or number) -> {text, bg, fg}; missing/unknown -> "NA" on default colors
export function statusDisplay(raw) {
    const code = raw == null ? undefined : TETRA_TO_DISPLAY[Number(raw)]
    const [bg, fg] = COLORS[code] ?? DEFAULT_COLORS
    return { text: code === undefined ? "NA" : String(code), bg, fg }
}
